<ng-container class="document-template">
    <div class="td-cnt-ext-doc-template">
        <div class="td-cnt-doc-template" [ngClass]="{'td-cnt-mobile' : isMobile}">
            <div [ngClass]="{ 'modal-content': true, 'pdf-preview-visible': isPreviewVisible && pdfSrc }">
                <div class="form-content">
                    <div class="td-cnt-title-doc-template">
                        <i class="fal fa-file-lines dialog-icon"></i>
                        <span class="te-title">{{'enquiryBook.showDocumentTemplate' | translate}} / {{enquiryNo}}</span>
                    </div>
                    <div class="top-right-button" *ngIf="!loading">
                        <teiasoft-select [labelText]="'commons.chooseLanguage' | translate" [isMobile]="isMobile"
                            [optionsList]="languageOptionList!" [spaceLabel]="true" [noMinWidth]="true"
                            [defaultValue]="this.selectedLang" (onSelected)="onSelectedLanguage($event)"
                            [readOnly]="false" style="margin-right: 1rem"></teiasoft-select>
                        <teiasoft-button (onClick)="openImportModal()"
                            [text]="'quotation.importFromExisting' | translate" [theme]="theme" [type]="'tb-primary'"
                            style="margin-bottom: 0.5vh;">
                        </teiasoft-button>
                    </div>
                    <div *ngIf="!loading" class="td-cnt-body-doc">
                        <mat-accordion class="accordion">
                            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{'quotation.header' | translate}}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <app-header-section *ngIf="step === 0" [header]="headerSection"
                                    (headerChange)="onHeaderChange($event)" [reset]="resetHeaderSection.bind(this)">
                                </app-header-section>
                            </mat-expansion-panel>

                            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{ 'quotation.technicalDescriptions' | translate
                                        }}</mat-panel-title>
                                </mat-expansion-panel-header>

                                <app-technical-description-section *ngIf="step === 1" [itemsSections]="itemsSection"
                                    [uncategorizedItems]="uncategorizedItems"
                                    (sectionChange)="onSectionChange($event.updatedSectionData, $event.originalSection)"
                                    (addItem)="addItemToSection($event.section, $event.item)"
                                    (removeItem)="removeItemFromSection($event.section, $event.item)"
                                    [reset]="resetTechnicalDescription.bind(this)"
                                    [saleOfficeCountry]="this.quotationData?.otherInfo?.salesOfficeCountry!">
                                </app-technical-description-section>
                            </mat-expansion-panel>


                            <mat-expansion-panel *ngIf="hasSpecificRequirementsSection" [expanded]="step === 2"
                                (opened)="setStep(2)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{'quotation.specificRequirements' | translate}}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <app-customer-special-requirements-section *ngIf="step === 2"
                                    [specificRequirements]="specificRequirementsSection"
                                    (specificRequirementsChange)="onSpecificRequirementsChange($event)"
                                    [reset]="resetSpecificRequirementsSection.bind(this)">
                                </app-customer-special-requirements-section>
                            </mat-expansion-panel>

                            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{'quotation.otherInformation' | translate}}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <app-other-information-section *ngIf="step === 3"
                                    [otherInformation]="otherInformationSection"
                                    (otherInformationChange)="onOtherInformationChange($event)"
                                    [reset]="resetOtherInformationSection.bind(this)">
                                </app-other-information-section>
                            </mat-expansion-panel>

                            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{'quotation.delivery' | translate}}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <app-delivery-section *ngIf="step === 4" [delivery]="deliverySection"
                                    (deliveryChange)="onDeliveryChange($event)"
                                    [reset]="resetDeliverySection.bind(this)">
                                </app-delivery-section>
                            </mat-expansion-panel>

                            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{'quotation.payment' | translate}}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <app-payment-section *ngIf="step === 5" [payment]="paymentSection"
                                    (paymentChange)="onPaymentChange($event)" [reset]="resetPaymentSection.bind(this)">
                                </app-payment-section>
                            </mat-expansion-panel>

                            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{'quotation.final' | translate}}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <app-final-section *ngIf="step === 6" [finalSection]="finalSection"
                                    (finalChange)="onFinalSectionChange($event)" [reset]="resetFinalSection.bind(this)">
                                </app-final-section>
                            </mat-expansion-panel>

                        </mat-accordion>
                    </div>
                </div>
                <!-- PDF Preview -->
                <div *ngIf="isGeneratingPdf" class="loader-container">
                    <div class="spinner"></div>
                </div>
                <div class="pdf-preview-content">
                    <div *ngIf="!isGeneratingPdf && isPreviewVisible && pdfSrc" class="iframe-container">
                        <iframe class="responsive-iframe" [src]="pdfSrc"></iframe>
                    </div>
                </div>
            </div>


            <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">

                <!-- Button to either generate or refresh PDF preview -->
                <teiasoft-button *ngIf="!isPreviewVisible" (onClick)="generatePdfPreview()" class="mr-5"
                    [text]="'quotation.generatePdfPreview' | translate" [theme]="theme" [isMobile]="isMobile"
                    [type]="'tb-primary'"></teiasoft-button>

                <!-- Refresh PDF preview button visible when preview is active -->
                <teiasoft-button *ngIf="isPreviewVisible" (onClick)="generatePdfPreview()" class="mr-5 "
                    [text]="'quotation.refreshPdfPreview' | translate" [theme]="theme" [isMobile]="isMobile"
                    [type]="isPdfPreviewInvalidated ? 'tb-active' : 'tb-secondary'"></teiasoft-button>

                <!-- Hide preview button -->
                <teiasoft-button *ngIf="isPreviewVisible" (onClick)="togglePreviewVisibility()" class="mr-5"
                    [text]="'quotation.hidePdfPreview' | translate" [theme]="theme" [isMobile]="isMobile"
                    [type]="'tb-primary'"></teiasoft-button>
                <div style="display: flex;flex: 1;"></div>
                <!-- Save as Draft -->
                <teiasoft-button (onClick)="onSaveClick(false)" class="mr-5" [type]="'tb-primary'"
                    [text]="'quotation.saveAsDraft' | translate" [isMobile]="isMobile"></teiasoft-button>

                <!-- Save as Final -->
                <teiasoft-button (onClick)="onSaveClick(true)" class="mr-5" [type]="'tb-secondary'"
                    [text]="'quotation.saveAsFinal' | translate" [isMobile]="isMobile"
                    [disabled]="isEditQuotationFlow()"></teiasoft-button>

                <teiasoft-button (onClick)="onCloseClick()" class="mr-5" [type]="'tb-cancel'"
                    [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
            </div>
        </div>
    </div>

    <app-import-quotation *ngIf="showImportModal" [theme]="theme" (closeModal)="onCloseImportModal($event)"
        (importConfiguration)="onImportConfiguration($event)"></app-import-quotation>

    <ng-template #confirmTemplate let-dialogRef="dialogRef">
        <div class="dialog">
            <div class="td-cnt-title-doc-template">
                <span class="te-title">
                    {{ 'quotation.resetToDefault' | translate }}
                </span>
            </div>
            <div class="td-cnt-body-doc">
                {{ 'quotation.confirmResetToDefault' | translate }}
            </div>
            <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
                <teiasoft-button class="ml-5" (onClick)="dialogRef.close(false)" [text]="'commons.no' | translate"
                    [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
                <teiasoft-button class="ml-5" (onClick)="dialogRef.close(true)" [text]="'commons.yes' | translate"
                    [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            </div>
        </div>
    </ng-template>
</ng-container>
